import React, { useCallback, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'
import useAudioPlayer from '../hooks/useAudioPlayer'
import { CapeeshColors } from '../../../../../assets/ColorPalette'

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        padding: '8px 0',
    },
    playButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 64,
        height: 64,
        borderRadius: '50%',
        border: '2px solid rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        cursor: 'pointer',
        transition: 'all 200ms ease',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(255, 255, 255, 0.6)',
        },
    },
    playButtonActive: {
        borderColor: CapeeshColors.BlueBright,
        backgroundColor: 'rgba(90, 180, 241, 0.2)',
    },
    icon: {
        fontSize: 28,
        color: '#FFFFFF',
    },
    iconPlaying: {
        animation: '$pulse 1.5s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%, 100%': { transform: 'scale(1)', opacity: 1 },
        '50%': { transform: 'scale(1.15)', opacity: 0.8 },
    },
    label: {
        fontFamily: 'Rubik',
        fontSize: 13,
        fontWeight: 400,
        color: 'rgba(255, 255, 255, 0.6)',
    },
}))

/**
 * ListenButtonInteraction — a play button for audio (interactiveElementType === 6).
 * Non-scored; auto-completes after first play.
 */
const ListenButtonInteraction = ({ testOption, audioMap, onComplete }) => {
    const classes = useStyles()
    const audioPlayer = useAudioPlayer()
    const [hasPlayed, setHasPlayed] = useState(false)

    const blobUrl = testOption.textAudioUrl
        ? audioMap[testOption.textAudioUrl]
        : null

    const handlePlay = useCallback(() => {
        if (!blobUrl) return
        audioPlayer.playAudio(blobUrl).then(() => {
            if (!hasPlayed) {
                setHasPlayed(true)
                if (onComplete) {
                    onComplete({
                        testOptionId: testOption.testOptionId,
                        answers: [],
                    })
                }
            }
        })
    }, [blobUrl, audioPlayer, hasPlayed, testOption.testOptionId, onComplete])

    return (
        <div className={classes.container}>
            <button
                className={`${classes.playButton} ${audioPlayer.isPlaying ? classes.playButtonActive : ''}`}
                onClick={handlePlay}
            >
                <VolumeUpIcon
                    className={`${classes.icon} ${audioPlayer.isPlaying ? classes.iconPlaying : ''}`}
                />
            </button>
            <Typography className={classes.label}>
                {testOption.text || 'Listen'}
            </Typography>
        </div>
    )
}

export default ListenButtonInteraction
